import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-sorting-arrow',
  templateUrl: './table-sorting-arrow.component.html',
  styleUrls: ['./table-sorting-arrow.component.css'],
})
export class TableSortingArrowComponent {

  @Input() orientation: 'UP' | 'DOWN' = 'UP';
  @Input() color: 'WHITE' | 'BLACK' | 'GREY' | 'LIGHT_GREY' | 'GREY_BACKG' = 'GREY';

  colorHex = {
    WHITE: '#FFF',
    BLACK: '#252525',
    GREY: '#B7B9BB',
    LIGHT_GREY: '#D0D0D0',
    GREY_BACKG: '#f2f0e9',
  }

  constructor() {
  }

}
